import { render, staticRenderFns } from "./wine_servicefee_report.vue?vue&type=template&id=723537bc&scoped=true"
import script from "./wine_servicefee_report.vue?vue&type=script&lang=js"
export * from "./wine_servicefee_report.vue?vue&type=script&lang=js"
import style0 from "./wine_servicefee_report.vue?vue&type=style&index=0&id=723537bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723537bc",
  null
  
)

export default component.exports